import { handleResponseOld, makePost } from './helpers';

/**
 * @category Item API
 * @see fetchItemFacets
 */
type FetchItemFacetsParams = {
    authToken?: string;
    deployment: string;
    ids: number[];
};
/**
 * Fetch Item facets by given ids from Item API service
 * @function fetchItemFacets
 * @category Item API
 * @param {FetchItemFacetsParams}
 * @see https://item-api-DEPLOYMENT.liveauctioneers.com/spa/small/item-facets
 * @see https://github.com/LIVEauctioneers/item-api/blob/master/src/inventory/routes/post-item-facets.ts
 */
const fetchItemFacets = ({ authToken, deployment, ids }: FetchItemFacetsParams) =>
    new Promise<any>((resolve, reject) => {
        const request = makePost({ authToken, deployment, path: '<ITEM-API>spa/small/item-facets' });
        request.send({ ids });
        request.end((err, response) => handleResponseOld({ err, reject, resolve, response }));
    });

export default {
    fetchItemFacets,
};
